
























import { Component, Prop, Vue } from 'nuxt-property-decorator'
import '~/assets/scss/v-tooltip.scss'
import { filterDateDM } from '~/assets/filters/date'
import { IStyle } from '~/assets/interfaces/classes'

@Component({
  filters: {
    filterDateDM,
  },
})
export default class ComponentProductAvailable extends Vue {
  @Prop({ type: Boolean, default: false }) readonly available!: boolean
  @Prop({ type: Boolean, default: false }) readonly hasStores!: boolean
  @Prop({ type: Number, default: null }) readonly quantity!: number | null
  @Prop({ type: String, default: 'шт' }) readonly unit!: string
  @Prop({ type: String, default: null }) readonly availableDate!: string
  // Когда наличие стоит в одной строке с чем-то ещё (например, с артикулом),
  // отступ снизу берёт на себя внешняя обёртка — свой мы не добавляем.
  @Prop({ type: Boolean, default: false }) readonly noMargin!: boolean

  private styleSpacer!: IStyle

  private get classWrapper() {
    return [
      this.$style.availableWrapper,
      ...(this.noMargin ? [] : [this.styleSpacer.mb16]),
    ]
  }

  private clickAvailable() {
    if (this.hasStores) {
      this.$emit('click')
    }
  }
}
